angular.module('vehicle-issue')
    .component('vehicleIssueNewBookingList', {
        bindings: {
            vehicleId: '<'
        },
        templateUrl: 'app/vehicle-issue/_new-booking-issues.html',
        controller: function ($scope, VehicleIssue) {
            this.$onInit = () => {
                this.filters = {
                    id: this.vehicleId,
                    size: 10,
                    unresolved: true
                }
                let filters = angular.copy(this.filters);
                VehicleIssue.table(filters).$promise.then(result => this.page = result)
            }
        }
    })
